import { H4, UL } from "../../../../AbstractElements";
import { SidebaType } from "../../../../Constant";
import { useAppDispatch, useAppSelector } from "../../../../Redux-Toolkit/Hooks";
import { addSidebarLayouts } from "../../../../Redux-Toolkit/Reducers/ThemeCustomizerSlice";
import Horizontal from "./Horizontal";
import Vertical from "./Vertical";

const SidebarType = () => {
  const dispatch = useAppDispatch();
  const { layout } = useAppSelector((state) => state.themeCustomizer);

  const handleSidebarType = (type: string) => {
    dispatch(addSidebarLayouts(type));
  };

  return (
    <div>
      <H4>{SidebaType}</H4>
      <UL className="sidebar-type layout-grid simple-list d-flex flex-row">
        <Vertical handleSidebarType={handleSidebarType} layout={layout} />
        <Horizontal handleSidebarType={handleSidebarType} layout={layout} />
      </UL>
    </div>
  );
};

export default SidebarType;
